// extracted by mini-css-extract-plugin
export default {"caption":"styles-module__caption--ecd3i","title":"styles-module__title--TFr48","description":"styles-module__description--e0Bi5"};